<template>
    <div style="margin-left: 30px;margin-top:-20px; " >
        <el-menu :default-active="activeIndex"  class="el-menu-vertical-demo" mode="horizontal" @select="handleOpen"  >
            <el-menu-item index="1">
                <span>基本设置</span>
            </el-menu-item>
            <el-menu-item index="2" >
                <span slot="title">开通应用</span>
            </el-menu-item>
            <el-menu-item index="3">
                <span>修改记录</span>
              <span style="color: red">首次开通数字化校园需在账号管理手动同步账号至数字化校园!</span>
            </el-menu-item>
            <!--<el-menu-item index="3">-->
                <!--<span slot="title">关联账号</span>-->
            <!--</el-menu-item>-->
            <el-tooltip class="item" effect="light" placement="left" :value="true">
                <div slot="content" style="color: #F56C6C;font-size: 14px"><b><i class="el-icon-message-solid"></i>修改配置后请点击此处保存</b></div>
                <el-button style="text-align: center;float: right;margin-top: 26px" type="primary" size="small" :disabled="is_submit" @click="submit('form')">确 定</el-button>
            </el-tooltip>
        </el-menu>
       <el-form  ref="form" v-loading='loading' :model="form"  :rules="rules" :inline-message=true>
           <div v-if="activeIndex==1">
               <product-head  :params="params" @changeHead="changeHead" :is_edit="true"></product-head>
               <el-form-item  label="学校域名：" label-width="120px" prop="cor_domain">
                   <el-col :span="6">
                       <el-input size="mini" v-model="form.cor_domain"><i slot="append">.21szxy.com</i></el-input>
                   </el-col>
                   <el-col :span="6" :offset="1">
                        <el-button type="text" @click="copyDomain(form.cor_domain)">复制地址</el-button>
                    </el-col>
               </el-form-item>
               <el-form-item  label="学校Logo：" label-width="120px" prop="fileList">
                   <el-upload  class="upload-demo" name="contractFile" action="api/order/upload" :headers=headers :on-error="uploadError" :on-success="uploadSuccess" :on-exceed="handleExceed" :on-preview="handlePreview" :on-remove="handleRemove" :file-list="form.fileList" :beforeUpload="beforeUpload" :limit="1"  list-type="picture" >
                       <el-button size="small" type="primary">点击上传</el-button>
                       <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb(<span style="color:red">只允许上传一张图片</span>)</div>
                   </el-upload>
               </el-form-item>
               <el-form-item label="备注：" label-width="100px" class="limit-configure">
                   <el-input style="width: 300px;" type="textarea" v-model="form.memo" :size="input_size"></el-input>
               </el-form-item>
           </div>
            <el-form-item v-if="activeIndex==2"    style="margin-top:20px;" prop="open_app">
                <!-- <el-button  type="primary" size="small" @click="selectApp" >{{check_all?"批量关闭":"批量开启"}}</el-button> -->
                <el-button  type="primary" size="small" @click="delAppDialog" >批量移除</el-button>
                <el-button  type="primary" size="small" @click="showAppDialog" >添加应用</el-button>
                <!-- <el-table v-if="table_open_app.length>0"
                        :data="table_open_app"
                        style="width: 100%">
                        <el-row></el-row>
                    <el-table-column prop="app_id" label="序号">
                    </el-table-column>
                    <el-table-column prop="app_name" label="应用名称"></el-table-column>
                    <el-table-column prop="type_name" label="类型"></el-table-column>
                    <el-table-column prop="" label="应用权限配置">
                        <template slot-scope="scope">
                           <el-button @click="show(scope.row)" type="primary" v-if="scope.row.app_id===28" >配置</el-button>
                            <el-button @click="show(scope.row)" type="primary" v-if="isConfigurableApp(scope.row.app_id)" >配置</el-button>
                            <div v-else>
                            <el-button  type="info" disabled >配置</el-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="操作">
                        <template slot-scope="scope">
                            <el-button @click="delApps(scope.row)" type="primary">移除</el-button>
                        </template>
                    </el-table-column>
                </el-table> -->
                <el-row class="row-bg" :gutter="10" v-for="(app_type_item) in app_type_name_map" :key="app_type_item.value">
                    <div class="header-contain">
                        <p>{{ app_type_item.name }}</p>
                    </div>
                    <el-row v-if="app_type_item.value == 1">
                        <el-col :span="4">
                            <div class="grid-content">序号</div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content">应用名称</div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content">图片</div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content">类型</div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content">应用权限配置</div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content">操作</div>
                        </el-col>
                    </el-row>
                    <el-row v-for="(app_item, app_index) in table_open_app" :key="app_index" v-show="app_item.type == app_type_item.value">
                        <el-col :span="4">
                            <div class="grid-content">{{ app_item.app_id }}</div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content">{{ app_item.app_name }}</div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content"><img class="grid-image" :src="app_item.homeIcon"></div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content">{{ app_item.type_name }}</div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content" v-if="!params.customer_product_list.includes(app_item.app_id)">
                                <el-button @click="show(app_item)" type="primary" v-if="isConfigurableApp(app_item.app_id)" >配置</el-button>
                                <div v-else>
                                    <el-button  type="info" disabled >配置</el-button>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="4" v-if="!params.customer_product_list.includes(app_item.app_id)">
                            <div class="grid-content"><el-button @click="delApps(app_item)" type="primary">移除</el-button></div>
                        </el-col>
                    </el-row>
                </el-row>
                <AppDialog v-if="appDialogVisible" 
                :display="appDialogVisible" 
                :check_list="check_ids"
                @closeAppDialog="closeAppDialog"
                @clickAppDialog="clickAppDialog"
                ></AppDialog>
            </el-form-item>
            <el-dialog :visible.sync="dialogVisible" :append-to-body='true'>
            <img width="100%" :src="dialogImageUrl" alt>
            </el-dialog>
        </el-form>

        <!--应用权限配置 目前只是针对作业系统设置-->
        <el-dialog title="应用权限配置" :visible.sync="dialogVisibleAppScope" width="42%" center @close="beforeAppConfigClose">
            <h4>基本信息</h4>
            <p>应用编号：{{config.app_id}}</p>
            <p>应用名称：{{config.app_name}}</p>
            <p>应用开关: <el-switch
                    v-model="config.is_open"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
            </el-switch></p>
            <p>有效期:<el-date-picker
                    v-model="config.time"
                    type="daterange"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="timestamp"
                    size="small"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
            </el-date-picker></p>
            <h4>权限设置</h4>

            <!--作业系统配置-->
            <p v-if="config.app_id == 28">单个账号发布作业总次数：<span><el-input type="text" v-model.number="config.number" size="small"></el-input></span></p>

            <!--走班排课(在线选课)配置-->
            <template v-if="config.app_id == 48">
                <el-checkbox v-model="config.permissions.allow_choose_module">选科管理</el-checkbox>
                <template v-if="config.permissions.allow_choose_module == true">
                    <el-checkbox v-model="config.permissions.allow_new_gaokao_mod">新高考模式</el-checkbox>
                    <el-checkbox v-model="config.permissions.allow_at_study_mod">四点半模式</el-checkbox>
                </template>
                <el-checkbox v-model="config.permissions.allow_course_module">排课管理</el-checkbox>
            </template>

            <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submit_app">确定</el-button>
            <el-button type="primary" @click="dialogVisibleAppScope = false">关 闭</el-button>
             </span>
        </el-dialog>

        <div v-if="activeIndex==3">
            <recorder :customer_id="$route.query['id']" :product_id="form.product_id" :product_list="params.product_list"></recorder>
        </div>
    </div>
</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }
    .grid-content {
        text-align: center;
    }
    .grid-image {
        width: 45px; 
        height: 45px;
        border-radius: 15%;
    }
    .row-bg {
        padding: 5px 0;
    }
</style>

<script>
import AttachmentService from "~/services/attachment";
import CommonService from "~/services/common";
import ProductHead from  "~/views/order/partial/product_head.vue";
import RelationForm from "~/views/customer/relationForm.vue";
import RelationDialog from "~/views/customer/dialog/relationDialog.vue";
import Params from "~/config/params";
import OrderService from "~/services/order";
import Recorder from "~/views/order/recoder/base.vue";
import AppDialog from "~/views/order/digitizedcampus/AppDialog.vue";
export default {
    components:{
        ProductHead,
        RelationForm,
        RelationDialog,
        Recorder,
        AppDialog
    },
    data() {

        var check_domain_url = (rule, value, callback) => {
                this.validate_url = true;
                if(!value){
                    this.validate_url = false;
                    callback(new Error('请设置合作域名'));
                }
                let is_active_url = /^[a-zA-Z0-9]+.?21szxy.?com/;

                if(!is_active_url.test(this.form.cor_domain_url)){
                    this.validate_url = false;
                    callback(new Error('请设置合法域名'));
                }

                CommonService.checkUrlIsExist({url:this.form.cor_domain_url,type:'21szxy.com'}).then(res=>{
                    if(!res.data.domain_url){
                        callback();
                    }
                    if(res.data.domain_url.toLowerCase() == this.form.cor_domain_url.toLowerCase() && res.data.customer_id != this.$route.query['id']){
                        this.validate_url = false;
                        callback(new Error('合作域名已经存在'));
                    }
                    callback();
                });
        }


        return {
            input_size: "mini",
            check_all:0,
            is_submit:false,
            dialogVisible:false,
            dialogVisibleAppScope:false,
            dialogImageUrl:'',
            activeIndex:'1',
            validate_url:true,
            allofapp:[],
            showRelation:false,
            loading:false,
            form:{
                order_id:'',
                product_id:'',
                cor_domain:'',
                cor_domain_url:'',
                fileList: [],
                open_app:[],
                memo:'',
            },
            check_ids: [],
            //定义应用配置格式 目前只针对作业系统
            config:{
                app_id:"",
                app_name:"",
                is_open:false,
                time:[],
                number: 15,
                permissions: {
                    allow_choose_module: true, // 选科管理模块
                    allow_new_gaokao_mod: true, // 新高考模式
                    allow_at_study_mod: true, // 4点半模式
                    allow_course_module: true
                }
            },

            headers:{
                "access-token":this.$store.getters.token
            },
            rules:{
                admin:[{required:true,message:'请设置管理员',trigger:'blur'}],
                cor_domain: [
                    { required: true, validator:check_domain_url, trigger: 'blur' },
                ],
            },
            appDialogVisible: false,
            table_open_app: [],
            app_type_name_map: [
                {
                    name: '基础配置应用',
                    value: 1
                },
                {
                    name: '教学备课应用',
                    value: 2
                },
                {
                    name: '教务管理应用',
                    value: 3
                },
            ]
        };
    },
    props:{
        params:{
            type:Object,
            required:true
        },
    },
    computed: {
    　　joinurl() {
    　　　　return this.form.cor_domain
    　　},

    },
    watch:{
        　　joinurl(newValue, oldValue) {
        　　　　this.form.cor_domain_url = newValue+'.21szxy.com';
        　　},
    },
    created(){
        if(typeof this.params.config != 'undefined'){
            this.form = Object.assign(this.form,this.params.config)
        }

        this.form.order_id = this.params.order_id;
        this.form.product_id = this.params.product_id;
        this.form.type = this.params.open_state;
        this.form.end_at = this.params.end_at;
        this.form.start_at = this.params.start_at;
        this.refreshCheckIds();
        console.log('进入：created111',  this.form,  this.form.open_app, this.check_ids, this.params);
    },
    mounted() {
    },
    methods:{
        /**
         * 修改头部信息
         * @param data
         */
        changeHead(data){
            this.form.type = data.type;
            this.form.end_at = data.end_at;
            this.form.start_at = data.start_at;
        },
        submit(formName){
            console.log('开通应用', this.form.open_app);
            if(this.form.open_app.length==0){
                this.$message({
                    message: '开通应用不能为空',
                    type: 'error'
                });
                return false;
            }
            if(!this.validate_url){
                this.$message({
                    message: '域名设置错误',
                    type: 'error'
                });
                return false;
            };
            if(this.is_submit) return false;
            this.$refs[formName].validate(valid => {
                if(valid) {
                    this.is_submit = true;
                    OrderService.reviseProduct(this.form).then(res => {
                        this.is_submit = false;
                        if (res.code == 0) {
                            this.$message({
                                message: res.msg=='success'?Params.REVISE_NOTICE:res.msg,
                                type: 'success'
                            });
                        }
                    }).catch(err => {
                        this.$message({message: "操作失败，系统异常", type: 'error'})
                        this.is_submit = false;
                    });
                } else {
                    return false;
                }
            })
        },
        handleOpen(key, keyPath) {
            this.activeIndex = key;
        },
        closeRelationDialog(show){
            this.showRelation = show;
        },
        /**
         * 关联账号
         * */
        relationAccount(data){
            console.log(data);
            this.$refs['relation-form'].getAlready()
        },
        handleDialogConfigureClose(){
            this.$emit('handleDialogConfigureShow','',this.form.product_id);
        },
        handleExceed(file, fileList){
            this.$message.warning(`只允许上传一张图片，请删除在进行重新上传`);
        },
        handleDialogConfigureShow(){
            this.$refs['form'].validate(valid=>{
                if(valid){
                    this.$emit('handleDialogConfigureShow',this.form);
                }
            })
        },
        handleClose(){
            this.$emit('handleDialogConfigureShow','',this.form.product_id);
        },
        handleDataInit(){
            this.$emit("handleDataInit",this.form);
        },
        /**@description 图片是上传处理 */
        handleRemove(file, fileList) {
            AttachmentService.del({file_path:file.url}).then(res=>{
                    this.form.fileList = [];
                });
        },
        handlePreview(file) {
            this.dialogVisible = true;
            this.dialogImageUrl = file.url;
        },
        uploadSuccess(response, file, fileList){
            if(response.code>0){
                this.$message({
                        message: response.msg,
                        type: 'error'
                });
            }else{
                this.form.fileList.push({"name":response.data.file_name,"url":response.data.file_path});
            }
        },
        uploadError(err, file, fileList){
            console.log('===');
        },
        beforeUpload(file){
            let extension = file.name.split('.')[1];
            let filesize = file.size / 1024 / 1024 < 50;
            let type = ['jpg','jpeg','png'];
            if(!_.includes(type,extension)){
                this.$message({
                        message: '上传格式不允许,只允许上传jpg,jpeg,png格式文件',
                        type: 'tips'
                });
                return false;
            }
            if (!filesize) {
                this.$message({
                        message: '上传文件大小不能超过50M',
                        type: 'error'
                });
                return false;
            }
        },

        // /** 获取学校开通产品的信息 */
        // getProductInfo(){
        //     CommonService.getSchoolProductInfo({customer_id:global.customer_id,product:this.params.code}).then(res=>{
        //         if(res.data){
        //             this.form.cor_domain = res.data.domain_url.split('.')[0];
        //             this.form.cor_domain_url = res.data.domain_url;
        //             if(res.data.logo_url){
        //                 this.form.basic_configure.fileList = [{name:'学校Logo展示图片',url:res.data.logo_url}];
        //             }
        //         }
        //     })
        // },
        //应用权限配置弹窗
        show(row){
            this.dialogVisibleAppScope = true;
            if(typeof row.config.app_id !=='undefined' &&  row.config.app_id){
                this.config = Object.assign(this.config,row.config);
            }else{
                this.config = Object.assign(this.config,row);
                this.config.time = [this.params.start_at,this.params.end_at]
            }
            console.log(this.config);
        },
        beforeAppConfigClose() {
            this.config = {
                app_id:"",
                app_name:"",
                is_open:false,
                time:[],
                number: 15,
                permissions: {
                    allow_choose_module: true, // 选科管理模块
                    allow_new_gaokao_mod: true, // 新高考模式
                    allow_at_study_mod: true, // 4点半模式
                    allow_course_module: true
                }
            };
        },
        //应用配置确定
        submit_app(){
            if(typeof this.config.number != "number"){
                this.$message({
                    message: '布置作业次数必须为整数',
                    type: 'warning'
                });
                return false;
            }
            let index = this.form.open_app.findIndex(i=>{return i.app_id===this.config.app_id});
            console.log(this.config);
            console.log(index);

            // 走班排课单独处理
            if ( this.config.app_id === 48) {
                if (this.config.permissions.allow_choose_module && !this.config.permissions.allow_new_gaokao_mod && !this.config.permissions.allow_at_study_mod) {
                    this.$message({
                        message: '新高考和四点半至少要选其中一个',
                        type: 'warning'
                    });
                    return;
                }
            }

            //console.log(this.allofapp[index] );
            if(this.form.open_app[index] && typeof this.form.open_app[index].config !=='undefined'){
                this.form.open_app[index].config = this.config;
                // this.form.open_app[index].is_open = this.config.is_open;
            }
            // this.form.open_app = this.form.open_app.filter(i=>{return i.is_open});
            console.log(this.form.open_app );
            this.submit('form');
            this.dialogVisibleAppScope = false;
        },

        // 判断数字化校园应用是否支持配置
        isConfigurableApp(appId) {
            let allowApps = [28, 48];
            return allowApps.indexOf(appId) !== -1;
        },

        showAppDialog() {
            this.appDialogVisible = true;
        },
        /**
            * 监听关闭弹窗
            * @param status
            */
        closeAppDialog() {
            this.appDialogVisible = false;
        },

        /**
            * 监听点击app
            * @param status
        */
        clickAppDialog(app) {
            this.form.open_app.push(app);
            this.refreshCheckIds();
        },

        refreshCheckIds(){
            this.check_ids = [];
            this.table_open_app = [];
            this.form.open_app.forEach(app => {
                this.check_ids.push(app.app_id);
                this.table_open_app.push(app);
            })
        },

        delApps(app){
            if(app.app_name == '基础数据' || app.app_name == '数据中心'){
                this.$message({
                    message: app.app_name + '无法移除',
                    type: 'error'
                })
                return false;
            }
            // 使用filter方法过滤子数组中的app_id
            this.form.open_app = this.form.open_app.filter(item => item.app_id != app.app_id);
            this.refreshCheckIds();
            this.$message({
                message: '移除成功',
                type: 'success'
            })
        },

        delAppDialog(){
            // 全部关闭-除了基础数据，这里直接用名称判断，用id上线后怕id会有出入
            this.form.open_app = this.table_open_app.filter(item => item.app_name == '基础数据' || item.app_name == '数据中心' || this.params.customer_product_list.includes(item.app_id));
            this.refreshCheckIds();
            this.$message({
                message: '移除成功',
                type: 'success'
            })
        },

        copyDomain(domain) {
            const textToCopy = domain + '.21szxy.com';
            navigator.clipboard.writeText(textToCopy).then(
                () => this.$message({
                message: '复制成功',
                type: 'success'
                }),
                () => this.$message({
                message: '复制失败',
                type: 'error'
                })
            );
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/views/order/digitizedcampusConfigure.vue